export default "__VITE_ASSET__53001dc2__"